






















	import { Vue, Component, Prop } from "../../Infrastructure/CorBase/CoreBase";

	@Component
	export default class BaseTLFileInput extends Vue {
		@Prop({ type: String, required: false, default: "" }) textLabel?: string;//popis před
        @Prop({ type: String, required: false, default: "" }) accept?: string;//popis před
		@Prop({ type: String, required: false, default: "0" }) textLabelWidth?: string;//šířka popisu
		@Prop({ type: String, required: false, default: "" }) texInput?: string;// šířka input pole
		@Prop({ type: String, required: false, default: "0" }) inputWidth?: string;// šířka input pole
		

		@Prop({ type: File, required: false, default: null }) value?: File;

		@Prop({ type: Boolean, required: false, default: false }) readonly?: boolean; //povinné pole
		@Prop({ type: Boolean, required: false, default: false }) required?: boolean; //povinné pole

		data() {
			return {
				file: null
			}
		}

		//načtení stylu
		get inputClass() {
			return {
				"inputDetailNoEdit": this.readonly,
				"inputDetailIsEdit": !this.readonly,
				"helpOverflowHidden": true
				//"label-design": false,
				//"form-control": false,
				//"input-texbox-design": true
			};

		}

		validate() {
			let result: boolean = false;
			if (this.required === false || this.readonly === true) {
				result = true;
			} else {
				if (this.value != null) {
					let inputText: string = this.value.name;
					if (inputText.length > 0) {
						result = true;
					}
				}
			}
			this.$emit('isCorrect', result);
			return result;
		}

		get model() { return this.value; }
		set model(value: any) {
			this.$emit("input", value);
		}
	}
